import { gql } from 'apollo-angular';

export const queryLead = gql`
  query getLead($ID: String!) {
     Lead(ID: $ID) {
      ID
      gender
      email
      firstName
      lastName
      phone
      pictureURL
      address {
        route
        streetNumber
        city
        country
        postalCode
      }
      languageID
      productIDs
      pointOfSale
      operationID
    }
  }
`;
